export default "__VITE_ASSET__BVuXebXb__"